import React from "react";

const TeamCard = ({ heading, teamMembers }) => {
  return (
    <div className="flex flex-col gap-[15px]">
      <h2 className="text-3xl font-bold text-left">{heading}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className="flex flex-col md:flex-row bg-white rounded-lg overflow-hidden shadow-md "
          >
            <div className="w-full md:w-[40%] h-auto md:min-h-[320px] overflow-hidden">
              <img
                src={member.imageUrl}
                alt={member.alt || member.name}
                className="w-full h-auto object-contain md:h-full md:object-cover object-center"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="w-full md:w-[60%] py-6 px-6 md:px-12 bg-[#f5f0fc]">
              <h3 className="text-xl font-bold">{member.name}</h3>
              <p className="mb-4 lg:w-[75%]">{member.designation}</p>
              <p className="text-sm">{member.description}</p>
              {member.knowMore && (
                <div className="mt-6 cursor-pointer">
                  <div className="relative inline-block">
                    <div className="absolute inset-0 translate-x-2 translate-y-2 rounded-lg bg-[#753ABF]"></div>
                    <a
                      href={member.knowMore}
                      target={"_blank"}
                      rel="noreferrer"
                      aria-label={`View more about ${member.name}`}
                      className="relative inline-flex items-center rounded-lg bg-black text-white px-6 py-3 font-bold shadow-md transition-transform hover:translate-x-[3px] hover:translate-y-[2px]"
                    >
                      View More
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamCard;
